import * as z from "zod";

export const getDefaultSenderAddress = {
  name: "getDefaultSenderAddress" as const,
  input: z.object({}),
  output: z.object({ name: z.string(), email: z.string(), domain: z.string() }),
};
